/**
 * @generated SignedSource<<7c04f2a6a8cc894b3993a201f72c025b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveWaitingPaymentMethodPixCreditCard_query$data = {
  readonly appEnv: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useGraphQLType_query">;
  readonly " $fragmentType": "PaymentActiveWaitingPaymentMethodPixCreditCard_query";
};
export type PaymentActiveWaitingPaymentMethodPixCreditCard_query$key = {
  readonly " $data"?: PaymentActiveWaitingPaymentMethodPixCreditCard_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveWaitingPaymentMethodPixCreditCard_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveWaitingPaymentMethodPixCreditCard_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appEnv",
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useGraphQLType_query",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "graphqlType",
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "278bb28cf9f8712d18131882d5ba5aeb";

export default node;
